import { render, staticRenderFns } from "./EnvBadge.vue?vue&type=template&id=7e76ebe8&"
import script from "./EnvBadge.vue?vue&type=script&lang=js&"
export * from "./EnvBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports